$(document).ready(function(){
  const shopLaunchUrl = window.location.href;  
  function getQueryParam(name) {
    var regex = new RegExp('[?&]' + name + '=([^&#]*)');
    var results = regex.exec(shopLaunchUrl);
    return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : null;
  }
  var email = getQueryParam('launch_email');
  var password = getQueryParam('launch_password');
  
  const autoLoginFormContainer = $('.launch-auto-login-form');
  if(email != null && password != null){
    $("body").append('<div class="login_form_loader"><div class="login_form_loader_in"><div class=""><img src="https://cdn.shopify.com/s/files/1/0026/6364/5257/files/Rolling-2.5s-200px.svg?9931456118350752984"></div></div></div>')
    autoLoginFormContainer.find('[name="customer[email]"]').val(email);
    autoLoginFormContainer.find('[name="customer[password]"]').val(password);
    autoLoginFormContainer.find('form').submit();
  }
});


